(function () {
	'use strict';
	
	var forms = new forms4i();
	var isRegistrationPage = document.getElementsByClassName("RegistrationForm")[0];
	var phoneMaskPattern, allSaleChecks, allProductChecks, allNewsChecks;	
	
	if(isRegistrationPage){
		if(document.getElementById("ZipCode")){
			if (document.getElementById("ZipCodeMask")) {
				var zipCodeMaskPattern = document.getElementById("ZipCodeMask").value;
				if (zipCodeMaskPattern != "") { // only used for CA
					VMasker(document.getElementById("ZipCode")).maskPattern(zipCodeMaskPattern);
				}
			}
		}
		
		phoneMaskPattern = document.getElementById("phoneMask").value;		
		
		// should these two if statements go into the form js file? MML
		if(document.getElementById("Phone")){
			if (phoneMaskPattern != "") {
				VMasker(document.getElementById("Phone")).maskPattern(phoneMaskPattern);
			}
		}
		if(document.getElementById("MobileNumber")){
			if (phoneMaskPattern != "") {
				VMasker(document.getElementById("MobileNumber")).maskPattern(phoneMaskPattern);
			}
		}
		
		var saleSection = document.getElementById("SaleSection"),
		productSection = document.getElementById("ProductSection"),
		newsSection = document.getElementById("NewsletterSection");		
		if (saleSection) {
			allSaleChecks = [].slice.call(saleSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
		if (productSection) {
			allProductChecks = [].slice.call(productSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
		if (newsSection) {
			if (newsSection.getElementsByTagName('ul').length > 0) {
				allNewsChecks = [].slice.call(newsSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
			}
		}
	}
	
	var getAjaxHeader = function(selector) {
		return { "__RequestVerificationToken": selector.getElementsByTagName('input')[0].getAttribute("value") };
	},
	saveEmailPreferences = function(emailAddress) {
        	var emailPrefs = "";
		function updateThis(elements){
			elements.forEach(function(el, index, array) {
				if(el.value != ''){
					if(el.checked){	
						emailPrefs += el.value + ":true,";
					} else{
						emailPrefs += el.value + ":false,";
					}
				}
			});
		}
	
		if (allSaleChecks) { updateThis(allSaleChecks); }
		if (allProductChecks) { updateThis(allProductChecks); }
		if (allNewsChecks) { updateThis(allNewsChecks); }

		var newUserData = {"emailPrefs" : emailPrefs, "emailAddress" : emailAddress };
		var newUserSubscription = ajax({
    			method: "POST",
                    url: "/Esp/SaveNewUserSubscriptions",
                    data: newUserData,
                    headers: getAjaxHeader(document.getElementById("registerForm"))
		});
	},
	
	formSuccess = function() { };
	
	/*if(document.getElementById("submitPassword")){ // CRB: I don't think this is used anywhere
		document.getElementById("submitPassword").addEventListener("click", function(e){
			forms.formValidation(document.getElementById("changePassForm"), formSuccess(), e);
		});
	}*/
	if(document.getElementById("btnSubmit")){
		document.getElementById("btnSubmit").addEventListener("click", function(e) { 
			if(document.getElementById("registerForm")){ // using this ID on all forms in registration
				forms.formValidation(document.getElementById("registerForm"), formSuccess(), e);
			}
			if (document.getElementById('Email')) {
				if (document.getElementsByClassName("RegistrationForm")[0]) { 
		    			saveEmailPreferences(document.getElementById('Email').value);
		    		}
		    	}
		});
	}
	if(document.getElementById("submitSMSVerifyCode")){
		document.getElementById("submitSMSVerifyCode").addEventListener("click", function(e){
			if (document.getElementById('code').value == "") {
				e.preventDefault();
				if (document.getElementById("ErrorBox")) {
					document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox")); // fix for IE11
				}
				document.getElementsByClassName("errorMessage")[0].classList.remove("hide");
				document.getElementById('code').classList.add("input-validation-error");
				document.getElementById('code').setAttribute("aria-invalid", "true");
			}
		});
	}
})();